import { useEffect, useState } from 'react';

function PasswordValidation({ password }) {
    const [validation, setValidation] = useState({
        lowercase: false,
        uppercase: false,
        number: false,
        specialChar: false,
        minLength: false,
    });

    useEffect(() => {
        setValidation({
            lowercase: /[a-z]/.test(password),
            uppercase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            minLength: password.length >= 8,
        });
    }, [password]);

    return (
        <div className="passowrdrestritiondiv" style={{ zIndex: "999" }}>
            {password && (!validation.lowercase || !validation.uppercase || !validation.number || !validation.specialChar || !validation.minLength) && (
                <>
                    <div className="passowrdrestritiondivtop">
                        <p className="minimumpasswodttrxpp">
                            The minimum password length is 8 characters and must
                            contain at least 1 lowercase letter, 1 capital letter, 1
                            number, and 1 special character.
                        </p>
                    </div>
                    <div className="passowrdrestritiondivbottom">
                        <div className="radionattstxtdibflx">
                            <div
                                className={`radiobacustomdesign ${validation.minLength ? "tick-green" : ""
                                    }`}
                            >
                                {validation.minLength && (
                                    <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                    ></i>
                                )}
                            </div>
                            <label className="radiobtntxtxtplalbel">
                                Minimum 8 characters
                            </label>
                        </div>

                        <div className="radionattstxtdibflx">
                            <div
                                className={`radiobacustomdesign ${validation.lowercase ? "tick-green" : ""
                                    }`}
                            >
                                {validation.lowercase && (
                                    <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                    ></i>
                                )}
                            </div>
                            <label className="radiobtntxtxtplalbel">
                                Lowercase letter
                            </label>
                        </div>

                        <div className="radionattstxtdibflx">
                            <div
                                className={`radiobacustomdesign ${validation.uppercase ? "tick-green" : ""
                                    }`}
                            >
                                {validation.uppercase && (
                                    <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                    ></i>
                                )}
                            </div>
                            <label className="radiobtntxtxtplalbel">
                                Capital letter
                            </label>
                        </div>

                        <div className="radionattstxtdibflx">
                            <div
                                className={`radiobacustomdesign ${validation.number ? "tick-green" : ""
                                    }`}
                            >
                                {validation.number && (
                                    <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                    ></i>
                                )}
                            </div>
                            <label className="radiobtntxtxtplalbel">Number</label>
                        </div>

                        <div className="radionattstxtdibflx">
                            <div
                                className={`radiobacustomdesign ${validation.specialChar ? "tick-green" : ""
                                    }`}
                            >
                                {validation.specialChar && (
                                    <i
                                        className="fa fa-check"
                                        style={{ color: "green" }}
                                    ></i>
                                )}
                            </div>
                            <label className="radiobtntxtxtplalbel">
                                Special character
                            </label>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
};

export default PasswordValidation;